<template>
  <TheQuestion v-if="$store.state.auth.isSignin">
    <template v-slot:buttons>
      <a-button
        style="margin: 5px;"
        shape="round"
        type="primary"
        class="fl-right"
        @click="apply"
        icon="file-done"
      >문의하기</a-button>
    </template>
    <a-input v-model="post.title" placeholder="제목을 입력하세요." />
    <a-textarea
      v-model="post.contents"
      style="margin-top: 0.35em"
      placeholder="내용을 입력하세요."
      :autosize="{ minRows: 12, maxRows: 24 }"
    />
  </TheQuestion>
</template>
<script>
import TheQuestion from "@/components/Question/TheQuestion";
import { mapActions } from "vuex";

export default {
  name: "QuestionCreate",
  components: { TheQuestion },
  data() {
    return {
      post: {
        title: "",
        contents: ""
      }
    };
  },
  methods: {
    ...mapActions(["applyQuestion"]),
    apply() {
      this.applyQuestion(this.post);
    }
  }
};
</script>